export default class Profitwell {
    [x: string]: any;
 	 static $inject = ['AuthService','$window'];
    constructor(AuthService, $window) {
        this.$window = $window;
        this.authService = AuthService;
    }

    setProfitwellUser() {
        if(this.$window.profitwell) this.$window.profitwell('user_email', this.authService.getUsername());
    }
}
